// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {CSSProperties} from 'react';
import cn from 'classnames';
import styles_f from './svg.module.less';
import {img_url} from './img_url';

interface i_svg_props {
    w?: number;
    h?: number;
    cls?: string;
    id?: string;
    on_click?: (e?:any)=>void;
}

export const Svg_img = (props:i_svg_props)=>{
    let {id, w, h, cls, on_click} = props;
    const id_with_ext = id.split('/').pop().split('\\').pop();
    const alt_name = id_with_ext.split('.').slice(0, -1).join('.');
    const w_h_cls = {
        '--wrapper_height': h+'px',
        '--wrapper_width': w+'px'
    } as CSSProperties;
    return <span style={w_h_cls} className={cn(styles_f.svg, cls && cls,
      !!on_click && styles_f.pointer)} onClick={()=>on_click && on_click()}>
      <img src={img_url(id)} width={w||'100%'} height={h||'100%'}
        alt={alt_name} className="lazyload"/>
    </span>;
};
